import React, { useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { useAuth, api } from "../context/AuthContext";
import { useToast } from "../hooks/use-toast";

// Avatar placeholder that lets members without a photo upload one in place
export const PhotoNudge = ({ initial }) => {
  const { setUser } = useAuth();
  const { toast } = useToast();
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const res = await api.post("/profile/avatar", fd);
      setUser((u) => ({ ...u, avatar_path: res.data.avatar_path }));
      toast({ title: "Looking good! Your photo is up." });
    } catch (err) {
      toast({ title: "Upload failed", description: err?.response?.data?.detail, variant: "destructive" });
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="group block cursor-pointer" data-testid="photo-nudge" title="Add your photo">
      <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={upload} disabled={busy} data-testid="photo-nudge-input" />
      <span className="relative flex h-20 w-20 items-center justify-center rounded-full bg-slate-100 text-2xl font-bold text-slate-600 ring-2 ring-offset-2 ring-[#FF4500]/40 transition-[box-shadow] duration-200 group-hover:ring-[#FF4500]">
        {busy ? <Loader2 className="h-6 w-6 animate-spin" /> : initial}
        <span className="absolute -bottom-0.5 -right-0.5 flex h-7 w-7 items-center justify-center rounded-full border-2 border-white bg-[#FF4500] text-white transition-transform duration-200 group-hover:scale-110">
          <Camera className="h-3.5 w-3.5" />
        </span>
      </span>
    </label>
  );
};

export const PhotoNudgeText = () => (
  <p className="mt-2 text-xs font-semibold text-[#FF4500]" data-testid="photo-nudge-text">Add a photo so crewmates know you</p>
);

export default PhotoNudge;
